<template>
  <div id="app">
    <div class="cascades">
      <div v-for="(cascade, index) in cascades" :key="index" :class="['cascade', `cascade-${index + 1}`]">
        <div v-for="(card, index2) in cascade" :key="index2"  :class="[`card-${index2 + 1}`]">
          <card :content="card"></card>
        </div>
        <!-- <span>1</span> -->
      </div>
    </div>
    <div class="deck-panel">
      <div class="bg bg-pingu pingu-1">
        <img src="@/assets/images/element-26.svg" alt="">
      </div>
      <div class="bg bg-pingu pingu-2">
        <img src="@/assets/images/element-25.svg" alt="">
      </div>
      <div class="bg bg-iceberg">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 904.71 526.95"><title>element</title><polygon class="cls-1" points="50.7 439.12 101.41 526.95 0 526.95 50.7 439.12"/><polygon class="cls-2" points="101.06 526.95 50.35 439.12 151.76 439.12 101.06 526.95"/><polygon class="cls-3" points="101.06 351.3 151.76 439.12 50.35 439.12 101.06 351.3"/><polygon class="cls-1" points="151.41 439.12 202.12 526.95 100.7 526.95 151.41 439.12"/><polygon class="cls-2 hidden" points="201.76 526.95 151.06 439.12 252.47 439.12 201.76 526.95"/><polygon class="cls-4 hidden" points="201.76 351.3 252.47 439.12 151.06 439.12 201.76 351.3"/><polygon class="cls-1 hidd2en" points="252.12 439.12 302.82 526.95 201.41 526.95 252.12 439.12"/><polygon class="cls-3 hidden" points="302.47 526.95 251.76 439.12 353.17 439.12 302.47 526.95"/><polygon class="cls-5 hidden" points="302.47 351.3 353.18 439.12 251.76 439.12 302.47 351.3"/><polygon class="cls-1 hidden" points="352.82 439.12 403.53 526.95 302.12 526.95 352.82 439.12"/><polygon class="cls-2 hidden" points="403.18 526.95 352.47 439.12 453.88 439.12 403.18 526.95"/><polygon class="cls-1 hidden" points="403.17 351.3 453.88 439.12 352.47 439.12 403.17 351.3"/><polygon class="cls-1 hidden" points="453.53 263.47 402.82 175.65 504.23 175.65 453.53 263.47"/><polygon class="cls-4 hidden" points="453.53 439.12 504.23 526.95 402.82 526.95 453.53 439.12"/><polygon class="cls-4 hidden" points="403.17 175.65 453.88 263.47 352.47 263.47 403.17 175.65"/><polygon class="cls-2 hidden" points="503.88 526.95 453.17 439.12 554.59 439.12 503.88 526.95"/><polygon class="cls-4 hidden" points="503.88 351.3 554.59 439.12 453.17 439.12 503.88 351.3"/><polygon class="cls-3 hidden" points="554.23 439.12 604.94 526.95 503.53 526.95 554.23 439.12"/><polygon class="cls-2 hidden" points="604.59 526.95 553.88 439.12 655.29 439.12 604.59 526.95"/><polygon class="cls-1 hidden" points="604.58 351.3 655.29 439.12 553.88 439.12 604.58 351.3"/><polygon class="cls-2 hidden" points="151.41 439.12 100.7 351.3 202.12 351.3 151.41 439.12"/><polygon class="cls-1 hidden" points="151.41 263.47 202.12 351.3 100.7 351.3 151.41 263.47"/><polygon class="cls-1 hidden" points="252.12 439.12 201.41 351.3 302.82 351.3 252.12 439.12"/><polygon class="cls-5 hidden" points="252.12 263.47 302.82 351.3 201.41 351.3 252.12 263.47"/><polygon class="cls-2 hidden" points="352.82 439.12 302.12 351.3 403.53 351.3 352.82 439.12"/><polygon class="cls-5 hidden" points="352.82 263.47 403.53 351.3 302.12 351.3 352.82 263.47"/><polygon class="cls-2 hidden" points="453.53 439.12 402.82 351.3 504.23 351.3 453.53 439.12"/><polygon class="cls-4 hidden" points="453.53 263.47 504.23 351.3 402.82 351.3 453.53 263.47"/><polygon class="cls-1 hidden" points="554.23 439.12 503.53 351.3 604.94 351.3 554.23 439.12"/><polygon class="cls-1 hidden" points="554.23 263.47 604.94 351.3 503.53 351.3 554.23 263.47"/><polygon class="cls-4 hidden" points="654.94 439.12 604.23 351.3 705.64 351.3 654.94 439.12"/><polygon class="cls-1 hidden" points="654.94 263.47 705.64 351.3 604.23 351.3 654.94 263.47"/><polygon class="cls-1 hidden" points="652.6 439.12 703.3 526.95 601.89 526.95 652.6 439.12"/><polygon class="cls-5 hidden" points="702.95 526.95 652.24 439.12 753.65 439.12 702.95 526.95"/><polygon class="cls-1 hidden" points="702.95 351.3 753.65 439.12 652.24 439.12 702.95 351.3"/><polygon class="cls-5 hidden" points="753.3 439.12 804.01 526.95 702.6 526.95 753.3 439.12"/><polygon class="cls-2 hidden" points="803.65 526.95 752.95 439.12 854.36 439.12 803.65 526.95"/><polygon class="cls-5 hidden" points="803.65 351.3 854.36 439.12 752.95 439.12 803.65 351.3"/><polygon class="cls-1 hidden" points="854.01 439.12 904.71 526.95 803.3 526.95 854.01 439.12"/><polygon class="cls-2 hidden" points="604.59 351.3 553.88 263.47 655.29 263.47 604.59 351.3"/><polygon class="cls-3 hidden" points="604.59 175.65 553.88 87.83 655.29 87.83 604.59 175.65"/><polygon class="cls-4 hidden" points="604.58 0 655.29 87.82 553.88 87.82 604.58 0"/><polygon class="cls-1 hidden" points="705.29 175.65 756 263.47 654.59 263.47 705.29 175.65"/><polygon class="cls-2 hidden" points="554.23 263.47 503.53 175.65 604.94 175.65 554.23 263.47"/><polygon class="cls-1 hidden" points="554.23 87.82 604.94 175.65 503.53 175.65 554.23 87.82"/><polygon class="cls-1 hidden" points="604.58 175.65 655.29 263.47 553.88 263.47 604.58 175.65"/><polygon class="cls-2 hidden" points="503.88 351.3 453.17 263.47 554.59 263.47 503.88 351.3"/><polygon class="cls-1 hidden" points="753.3 439.12 702.6 351.3 804.01 351.3 753.3 439.12"/><polygon class="cls-3 hidden" points="753.3 263.47 804.01 351.3 702.6 351.3 753.3 263.47"/><polygon class="cls-2 hidden" points="702.95 351.3 652.24 263.47 753.65 263.47 702.95 351.3"/><polygon class="cls-3 hidden" points="503.88 175.65 554.59 263.47 453.17 263.47 503.88 175.65"/><polygon class="cls-2 hidden" points="654.94 87.82 705.64 175.65 604.23 175.65 654.94 87.82"/><polygon class="cls-5 hidden" points="654.94 263.47 604.23 175.65 705.64 175.65 654.94 263.47"/><polygon class="cls-5 hidden" points="403.18 351.3 352.47 263.47 453.88 263.47 403.18 351.3"/><polygon class="cls-2 hidden" points="302.47 351.3 251.76 263.47 353.17 263.47 302.47 351.3"/><polygon class="cls-1 hidden" points="302.47 175.65 353.18 263.47 251.76 263.47 302.47 175.65"/></svg>
        <!-- <img src="@/assets/images/element_ice.svg" alt=""> -->
      </div>
      <div class="open-cells">
        <div class="cell"></div>
        <div class="cell"></div>
        <div class="cell"></div>
        <div class="cell"></div>
      </div>
      <div class="functions">
        <div class="func">
          <button>
            <img src="@/assets/images/element-14.svg" alt="">
          </button>
          <button>
            <img src="@/assets/images/element-16.svg" alt="">
          </button>
          <button>
            <img src="@/assets/images/element-15.svg" alt="">
          </button>
        </div>
        <div class="score">
          <div>Score｜</div>
          <div>000</div>
        </div>
        <div class="time">
          <div>Time｜</div>
          <div>00:00</div>
        </div>
      </div>
      <div class="foundations">
        <div class="foundation"></div>
        <div class="foundation"></div>
        <div class="foundation"></div>
        <div class="foundation"></div>
      </div>
    </div>
  </div>
</template>

<script>
import card from './components/card.vue'

export default {
  name: 'app',
  components: {
    card
  },
  data () {
    return {
      suits: ['spade', 'diamond', 'heart', 'club'],
      numbers: ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'],
      poker: [],
      cascades: [
        [], [], [], [], [], [], [], []
      ]
    }
  },
  created() {
    this.cascadesInit()
    // this.poker.sort(this.shuffle)
  },
  methods: {
    cascadesInit () { // 重新洗牌發牌
      this.poker = this.generateAllDeck()  // 產生牌組
      this.poker.sort(this.shuffle)  // 洗牌
      // 發牌
      let i = 0
      while (this.poker.length > 0) {
        // console.log(this.poker.length)
        this.cascades[i].push(this.poker.pop())
        i++
        i = i % 8
      }
    },
    generateAllDeck () {
      let poker = []
      for (let i = 0; i < this.suits.length; i++) {
        for (let j = 0; j < this.numbers.length; j++) {
          // console.log(i, j, sthis.suits[i])
          let item = {
            suit: this.suits[i],
            number: this.numbers[j]
          }
          poker.push(item)
        }
      }
      return poker
    },
    shuffle() {
      let num = Math.random() > 0.5 ? -1 : 1
      return num
    },
    randomNum (min,max) {
      Math.floor(Math.random() * max) + 1
    }
  }
}
</script>

<style lang="scss" scoped>
$nums: 13;
@mixin card-display {
  @for $i from 1 through $nums {
    .card-#{$i} {
      position: absolute;
      width: 95%;
      height: auto;
      top: (10 * ($i - 1)) * 5px;
    }
  }
}

#app {
  .cascades {
    height: 80%;
    padding: 40px 80px;
    background-color: #2A4254;
    color: #fff;
    display: flex;
    .cascade {
      position: relative;
      z-index: 10;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // margin: 0 5px;
      @include card-display;
    }
  }
  .deck-panel {
    position: relative;
    height: 20%;
    background-color: #C7E7FF;
    display: flex;
    padding: 0 20px;
    .open-cells {
      position: relative;
      flex: 2;
      display: flex;
      justify-content: space-evenly;
      .cell {
        position: relative;
        top: -10px;
        width: 22.5%;
        height: 100%;
        border: 2px solid #fff;
        border-radius: 10px;
      }
    }
    .functions {
      padding: 5px 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-content: center;
      .func {
        flex: 3;
        button {
          background-color: transparent;
          width: 30%;
          cursor: pointer;
        }
      }
      .score, .time {
        flex: 2;
        display: flex;
        justify-content: center;
        align-items: center;
        div {
          display: inline-block;
          width: 50%;
          font-size: 1.5rem;
          font-weight: 800;
          color: #2A4254;
          &:first-child {
            text-align: right;
          }
          &:last-child {
            text-align: left;
          }
        }
      }
    }
    .foundations {
      flex: 2;
      display: flex;
      justify-content: space-evenly;
      .foundation {
        position: relative;
        background-color: rgba(#fff, .2);
        top: -10px;
        width: 22.5%;
        height: 100%;
        border: 2px solid #fff;
        border-radius: 10px;
        &:after {
          content: 'A';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          color: rgba(#282828, .2);
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 900;
          font-size: 3rem;
        }
      }
    }
    .bg {
      position: absolute;
      bottom: 95%;
      img {
        width: 100%;
        transform: scaleX(-1);
      }
      &.pingu-1 {
        width: 3%;
        left: 3%;
      }
      &.pingu-2 {
        width: 3%;
        left: 12%;
      }
      &.bg-iceberg {
        display: flex;
        justify-content: flex-end;
        bottom: 100%;
        width: 40%;
        right: 1%;
        svg {
          width: 100%;
          .hidden {
            display: none;
          }
          .cls-1{fill:#5694c4;}.cls-2{fill:#a1d2f7;}.cls-3{fill:#316f9e;}.cls-4{fill:#e9f5fe;}.cls-5{fill:#c7e7ff;}
        }
      }
    }
  }
}
</style>

<style lang="scss">
html, body, #app {
  height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    box-sizing: border-box;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
    display: block;
}
body {
    line-height: 1;
}
ol, ul {
    list-style: none;
}
blockquote, q {
    quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
    content: '';
    content: none;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
}
input, button {
  border: none;
  outline: none;
}
</style>
